
import styled from 'styled-components';

export default styled.div`
	width: 100%;
  
	display: flex;
	align-items: center;
	justify-content: center;
  flex-direction: column;

  margin-bottom: 2em;

  .person-info {
    width: 100%;

    @media only screen and (min-width: 600px){
      flex-direction: row;
      .ui.image {
        max-width: 30vw;
        max-height: 30vw;
      }
    }
  }

  .person-reports {
    width: 100%;
    padding: 1em;
  }
`;